import React from "react";
import useCurrency from "../../../../../hooks/useCurrency";

import {

    Card,
    Statistic,
    Button,
    Space,
    Tag

} from "antd";

const OfferCard = ({

                       offer,

                       onAccept

                   }) => {

    const { symbol } = useCurrency();

    return (

        <Card

            style={{

                borderRadius:12,

                border:"1px solid #52c41a",

                marginBottom:18

            }}

        >

            <Tag color="green">

                Proposition du vendeur

            </Tag>

            <Space

                direction="vertical"

                style={{

                    width:"100%",

                    marginTop:20

                }}

            >

                <Statistic

                    title="Prix proposé"

                    value={offer.negotiatedUnitPrice}

                    suffix={symbol(offer.currency)}

                />

                <Statistic

                    title="Kg / paquet"

                    value={offer.negotiatedPacketQuantity}

                />

                <Statistic

                    title="Stock disponible"

                    value={offer.negotiatedAvailablePackets}

                    suffix="paquets"

                />

                <Button

                    type="primary"

                    onClick={onAccept}

                >

                    Accepter cette proposition

                </Button>

            </Space>

        </Card>

    );

};

export default OfferCard;